import React from 'react'

/* doc
---
title: ModalCardBody
name: ModalCardBody
category: React - Bulma
---

A `ModalCardBody` component based on Bulma `.modal-card-body`. The body of the ModalCard

This should be used with `ModalCard`

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalBackground />
    <ModalCard>
      <ModalCardHead>
        <ModalCardTitle>
          ...
        </ModalCardTitle>
      </ModalCardHead>
      <ModalCardBody>
        ...
      </ModalCardBody>
      <ModalCardFoot>
        ...
      </ModalCardFoot>
    </ModalCard>
  </Modal>
```
*/
function ModalCardBody(props) {
  const { className, children, ...rest } = props

  const classes = [
    'bulma-modal-card-body',
    className || '',
  ]

  return (
    <section {...rest} className={classes.join(' ')}>
      {children}
    </section>
  )
}

export default ModalCardBody
